import Icon from "./Icon";

type RoomDetailItemProps = {
  icon: string;
  label: string;
};

export default function RoomDetailItem({ icon, label }: RoomDetailItemProps) {
  return (
    <div className="flex items-center gap-2.5">
      <Icon name={icon} size="lg" className="text-white/90" />
      <span className="text-sm md:text-base font-light text-white/95">{label}</span>
    </div>
  );
}

